import { render } from "./SelectMask.vue?vue&type=template&id=3b5ef9ea&scoped=true"
import script from "./SelectMask.vue?vue&type=script&lang=js"
export * from "./SelectMask.vue?vue&type=script&lang=js"

import "./SelectMask.vue?vue&type=style&index=0&id=3b5ef9ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b5ef9ea"]])

export default __exports__